import probingOperations from './probing/operations';

export function ProbingHandles(props) {
  const {
    op,
    children
  } = props;

  const {
    cmd
  } = op;

  const OperationHandles = probingOperations[cmd] || 'group';

  return <group>
  <OperationHandles op={op}>
  { children }
  </OperationHandles>
  </group>
}


export default ProbingHandles;
